import React, {
	Component
} from 'react';
import styled from 'styled-components';

import { store } from '../stores/mainStore';

const config = window.dodConfig;

const ScoringPage = styled.div`
	/* margin-top: 35%; */
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	background: rgba(0,0,0, 0.75);
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
	font-size: 32px;
	pointer-events: auto;
`

const Content = styled.div`
	display: flex;
	width: 80%;
	height: 100%;
	padding-top: ${p => 30}%;
	box-sizing: border-box;
	background-size: 100% auto;
	text-align: center;
	flex-direction: column;
`

const CloseBox = styled.div`
	position: relative;
	display: inline-block;
	width: ${p => config.isLandscape ? 56 : 100}%;
	margin: 0 auto;
`

const BoxContent = styled.img`
	width: 100%;
`

const CloseButton = styled.img`
	width: 12%;
	position: absolute;
	top: -5%;
	right: ${p =>  1}%;
`
export class ModalRanking extends Component {

	continue(){
		window.manager.playAudio("poopPop");
		store.modal = '';
	}

	// learn(){
	// 	store.modal = 'learn';
	// }

	render() {
		return (
			<ScoringPage>
				<Content>
					<CloseBox>
						<CloseButton src="/assets/btn_close.png" onClick={e => store.modal = ''}/>
						<BoxContent src={`/assets/languages/${store.settings.language}/hand_ranks.png`}/>
					</CloseBox>
					{/* <ButtonBar>
						<Button learnmore onClick={this.learn}/>
					</ButtonBar> */}
				</Content>
			</ScoringPage>
		)
	}
}
